import React from 'react';
import SvgIcon from './SvgIcon';

const Earthquake = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M23.5 23.113v-12h-9.488l-1.462 2.253a.5.5 0 00.141.688l2.714 1.814a.5.5 0 01.043.8l-1.873 1.575a.5.5 0 00.03.789l.328.235a.5.5 0 01.058.764l-3.158 3.084.518-3.107a.5.5 0 00-.3-.545l-1.2-.493a.5.5 0 01-.132-.845l1.733-1.457a.5.5 0 00-.043-.8l-2.718-1.814a.5.5 0 01-.141-.688l1.462-2.253H.5v12M4.5 11.113v-3M7.692 7.412a.5.5 0 01-.458.7H1.766a.5.5 0 01-.458-.7l2.734-6.226a.5.5 0 01.916 0l2.734 6.226zM19.5 11.113v-3M22.692 7.412a.5.5 0 01-.458.7h-5.468a.5.5 0 01-.458-.7l2.734-6.226a.499.499 0 01.916 0l2.734 6.226z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Earthquake.displayName = 'EarthquakeIcon';

export default Earthquake;
